import { Controller } from "@hotwired/stimulus"

// Circular progress indicator controller
// Displays a circular SVG progress ring based on a percentage value
export default class extends Controller {
  static targets = ["circle"]
  static values = { percent: { type: Number, default: 0 } }

  connect() {
    this.updateProgress()
  }

  percentValueChanged() {
    this.updateProgress()
  }

  updateProgress() {
    if (!this.hasCircleTarget) return

    const circle = this.circleTarget
    const radius = circle.r.baseVal.value
    const circumference = 2 * Math.PI * radius
    const percent = Math.min(100, Math.max(0, this.percentValue))
    const offset = circumference - (percent / 100) * circumference

    circle.style.strokeDasharray = `${circumference}`
    circle.style.strokeDashoffset = `${offset}`
  }
}
